import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Configuracion = {
    obtenerConfiguracion: async () => {
        let url = url_json + "/configuracion"
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarConfiguracion: async data => {
        let url = url_json + "/configuracion"
        let request = {
            method: 'PATCH',
            body: JSON.stringify(data),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();

        if (response.ok) {
            Swal.fire('Modificación exitosa!', 'La configuración se actualizó correctamente', 'success')
        } else {
            Swal.fire('Error!', 'No se pudo actualizar la configuración', 'error')
        }
        return { success: response.ok, data: res.data };
    },
}

export default Configuracion;
